import React from 'react';
import Header from './Header/Header';
import PropTypes from 'prop-types';
import './MountCustom.css';

const MountCustom = ({ children, className = '', ...props }) => {
  
  return (
    <>
      <Header />
      
      <div className={`customMount ${className}`} {...props}>
      {children}
    </div>
    
    </>
  
  );
};

MountCustom.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default MountCustom;
